import Typography from '@mui/material/Typography';
import ReactMarkdown from 'react-markdown';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { useQuery } from 'react-query';
import useIsMobile from '../../hooks/useIsMobile';
import { GetPreLoginAnnouncementsFn } from '../../data/apiCalls';
import MarkdownLinkRenderer from './MarkdownLinkRenderer';
import MarkdownParagraphRenderer from './MarkdownParagraphRenderer';
import MarkdownUnorderListRenderer from './MarkdownUnorderedListRenderer';
import MarkdownListItemRenderer from './MarkdownListItemRenderer';

const markdownComponents = {
	a: MarkdownLinkRenderer,
	p: MarkdownParagraphRenderer,
	ul: MarkdownUnorderListRenderer,
	li: MarkdownListItemRenderer,
};

const PreLoginAnnouncementBanner = () => {
	const isMobile = useIsMobile();

	const { data: announcementsResponse } = useQuery(
		['PreLoginAnnouncements'],
		() => GetPreLoginAnnouncementsFn(),
		{
			staleTime: Infinity,
			cacheTime: Infinity,
			refetchOnWindowFocus: false,
			retry: false,
		}
	);

	const announcements =
		announcementsResponse?.data?.data?.announcements ?? [];

	if (announcements.length === 0 || isMobile) {
		return null;
	}

	return (
		<Box
			data-testid='warning-banner'
			sx={{
				justifyContent: 'center',
				marginBottom: 2,
				mx: 3,
			}}
		>
			<Stack spacing={0}>
				{announcements.map(announcement => (
					<Alert key={announcement.id} severity='warning'>
						<Typography sx={{ '& p': { m: 0 } }}>
							<ReactMarkdown components={markdownComponents}>
								{announcement.body}
							</ReactMarkdown>
						</Typography>
					</Alert>
				))}
			</Stack>
		</Box>
	);
};

export default PreLoginAnnouncementBanner;
